import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import PostCard from "../components/PostCard";
import { RightRail } from "../components/Layout";
import { useFeedCache, readFeedCache, restoreScroll } from "../hooks/useFeedCache";
import { Loader2, Bookmark } from "lucide-react";

export default function Saved() {
  const cached = readFeedCache("saved");
  const [items, setItems] = useState(cached?.items || []);
  const [loading, setLoading] = useState(!cached?.items);

  useEffect(() => {
    if (cached?.items) { restoreScroll(cached.scrollY); return; }
    let alive = true;
    setLoading(true);
    api.get("/saved", { params: { limit: 100 } })
      .then(({ data }) => { if (alive) setItems(data || []); })
      .catch(() => {})
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useFeedCache("saved", items);

  return (
    <div className="flex justify-center gap-6 px-2 sm:px-4 py-4">
      <div className="w-full max-w-[600px]" data-testid="saved-column">
        <div className="flex items-center gap-3 mb-4 px-1">
          <span className="w-10 h-10 rounded-full flex items-center justify-center bg-[#00E5FF]/15">
            <Bookmark size={20} className="text-[#00E5FF]" fill="#00E5FF" />
          </span>
          <div>
            <h1 className="text-[#FFFFFF] font-heading text-2xl uppercase tracking-tight leading-none">Saved for later</h1>
            <p className="text-[#52525B] text-xs mt-1">Only you can see this collection.</p>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center py-24"><Loader2 className="animate-spin text-[#00E5FF]" size={30} /></div>
        ) : items.length === 0 ? (
          <div data-testid="saved-empty" className="bg-[#0A0A0A] border border-[#1C1C1F] rounded-xl p-10 text-center">
            <Bookmark size={30} className="text-[#00E5FF] mx-auto mb-3" />
            <p className="text-[#FFFFFF] font-semibold text-lg mb-1">Nothing saved yet</p>
            <p className="text-[#A1A1AA] text-sm mb-5">Tap the bookmark on any post to stash it here for later.</p>
            <Link to="/" className="inline-block px-6 py-2.5 rounded-md bg-[#00E5FF] hover:bg-[#00c9e0] text-black font-semibold text-sm transition-colors">Browse the feed</Link>
          </div>
        ) : (
          items.map((item) => <PostCard key={item.id} item={item} />)
        )}
      </div>
      <aside className="hidden xl:block w-[320px] shrink-0 sticky top-14 h-[calc(100vh-3.5rem)] overflow-y-auto custom-scrollbar">
        <RightRail />
      </aside>
    </div>
  );
}
